import { SocialAccountProviders } from '@business/entities/account';
import { SocialAccountStatus, UserResponse, UserRole, UserType } from './../../entities/account/UserResponse';
import { Session } from '@modules/auth/session';

export function getSocialProviderColor(provider: SocialAccountProviders) {
  switch (provider) {
    case SocialAccountProviders.gmail:
      return '#c71610';
    case SocialAccountProviders.yahoo:
      return '#720e9e';
    case SocialAccountProviders.outlook:
      return '#0072c6';
    case SocialAccountProviders.eas:
      return '#08851b';
    case SocialAccountProviders.icloud:
      return '#78C5EF';
    case SocialAccountProviders.custom:
      return '#000000';
    default:
      return '#000000';
  }
}

export function getSocialStatusTitle(status: SocialAccountStatus) {
  switch (status) {
    case SocialAccountStatus.active:
      return 'Active';
    case SocialAccountStatus.invalid:
      return 'Invalid';
    case SocialAccountStatus.stopped:
      return 'Stopped';
    default:
      return status;
  }
}

export function getSocialStatusBadge(status: SocialAccountStatus) {
  switch (status) {
    case SocialAccountStatus.active:
      return 'success';
    case SocialAccountStatus.invalid:
      return 'danger';
    case SocialAccountStatus.stopped:
      return 'warning';
    default:
      return 'info';
  }
}

export function isAdmin(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin : false;
}

export function isStaff(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin || user.role === UserRole.user : false;
}

export function isSubContractor(user?: UserResponse | null) {
  return user ? user.role === UserRole.subcontractor : false;
}

export function isClient(user?: UserResponse | null) {
  return user ? user.role === UserRole.ClientPortal : false;
}

export function firstName(name: string) {
  return name.split(' ')[0];
}

export function firstNameWithLastInitial(name: string) {
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return parts[0] + ' ' + parts[1][0] + '.';
  } else {
    return parts[0];
  }
}

export function getAllUserTypes(): UserType[] {
  return [UserType.fullTime, UserType.partTime, UserType.contractor, UserType.asNeeded];
}

export function getUserTypeLabel(type: UserType) {
  switch (type) {
    case UserType.fullTime:
      return 'Full Time Employee';
    case UserType.partTime:
      return 'Part Time Employee';
    case UserType.contractor:
      return 'Contractor';
    case UserType.asNeeded:
      return 'As Needed';
    default:
      return type;
  }
}

export function getUserTypeItems() {
  return getAllUserTypes().map(type => ({ label: getUserTypeLabel(type), value: type }));
}

export function isAuthUserAdmin() {
  return isAdmin(Session.user);
}

export function isAuthUserStaff() {
  return isStaff(Session.user);
}

export function isAuthSubcontractor() {
  return isSubContractor(Session.user);
}
